import {signOut} from "firebase/auth";
import {auth} from "../../Components/MiddlePopup/SignInModal/firebaseConfig.ts";
import {setLoggedOutSettings} from "../db/users/setupUserState.ts";
import {isMobileApp} from "./envNameUtils.ts";

export const handleLogout = async (setSettingsObj: any, environment: string, vscode: any, setUserObj: any, setDynamicStateObj: any, resetStateHelper: any) => {
    try {
        await signOut(auth);
        setUserObj({user: null});

        resetStateHelper();
        setDynamicStateObj({chatHistory: [], isMenuOpen: false});
        setLoggedOutSettings(setSettingsObj);

        const loggedOutArgs = JSON.stringify({
            functionName: "userLoggedOut",
            data: [{ _: "_" }]
        });

        if (environment.includes("jetbrains")) {
            window.jetbrainsPostMessage(loggedOutArgs);
        } else if (environment === "vscode") {
            vscode.postMessage(loggedOutArgs);
        } else if (isMobileApp(environment)) {
            window.ReactNativeWebView.postMessage(JSON.stringify({
                functionName: "giveUserId",
                data: [{ userId: null }]
            }));
        }
    } catch (error) {
        console.error("Error signing out: ", error);
    }
};

export const getIdToken = async (user: any) => {
    if (!user) {
        return "NOT_AUTHENTICATED";
    }

    return await user.getIdToken();
}

export const safeLocalStorage = {
    getItem: (key: string): string | null => {
        try {
            const env = localStorage.getItem(key);
            if (!env || env === "null") return null;
            else return localStorage.getItem(key);
        } catch (e) {
            return null
        }
    },
    setItem: (key: string, value: string): void => {
        try {
            localStorage.setItem(key, value);
        } catch (e) {}
    }
};

export const safeGetVscode = () => {
    try {
        return window.acquireVsCodeApi();
    } catch (e) {}
}
